import { render, staticRenderFns } from "./DetailsTheListOf.vue?vue&type=template&id=4e0a9b8f&scoped=true&"
import script from "./DetailsTheListOf.vue?vue&type=script&lang=js&"
export * from "./DetailsTheListOf.vue?vue&type=script&lang=js&"
import style0 from "./DetailsTheListOf.vue?vue&type=style&index=0&id=4e0a9b8f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0a9b8f",
  null
  
)

export default component.exports